// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-editor-click-guard[data-v-66e810ba] {
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-elements/Feed.vue","webpack://./Feed.vue"],"names":[],"mappings":"AAGA;EACE,iBAAA;ACFF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n// No layout box; stays in the event path without shifting SmartFeed.\n.feed-editor-click-guard {\n  display: contents;\n}\n",".feed-editor-click-guard {\n  display: contents;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
